import { useAudio } from '@utils/providers/audio-context.tsx';
import { motion } from 'framer-motion';
import { useSharedCaption } from '@utils/providers/shared-caption-context.tsx';

const SharedCaptionMediaSlider = () => {
  const { currentTime, duration } = useAudio();
  const { setTimeAndSegment } = useSharedCaption();

  return (
    <div className={'flex items-center h-full'}>
      <motion.input
        type="range"
        value={currentTime}
        className="w-full h-2 bg-gray-400 rounded-2xl appearance-none cursor-pointer"
        onChange={e => setTimeAndSegment(parseFloat(e.target.value))}
        aria-labelledby="continuous-slider"
        max={duration}
        min={0}
      />
    </div>
  );
};

export default SharedCaptionMediaSlider;
